import React, { useState, useEffect } from "react";
import { BsCheckCircle } from "react-icons/bs";
import numeral from "numeral";
import moment from 'moment';
import variablesDomain from "../../helpers/variablesDomain";
import { FormatAmount, FormatCreditCard } from "../common/functions";

export default function ModalRecargaCard({ info, setShowModal, handleOk = () => { } }) {
    const title = "Recarga exitosa";

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-pop-up my-6 mx-auto max-w-md">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <button
                            className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                            onClick={() => setShowModal(false)}
                        >
                            <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                ×
                            </span>
                        </button>
                        <div className="relative px-6 pb-1 flex-auto">
                            <h3 className="text-3xl font-bold text-trixel-popup centrar-contenido">{title}</h3>
                            <div className="flex justify-center items-center mt-4 mb-8">
                                <img src={require('../../assets/images/approve.png')} style={{ width: 75, height: 75 }} />
                            </div>

                            <div className="my-4 py-2 mb-1 text-lg leading-relaxed border border-solid text-gray-700 rounded">
                                <div className="flex items-center px-1 leading-7">
                                    <p className="rounded-full mr-4 text-sm w-6/12 text-left">Tarjeta</p>
                                    <p className="rounded-full text-sm w-6/12 text-right">{FormatCreditCard(info.creditCard, true)}</p>
                                </div>
                                <div className="flex items-center px-1 leading-7">
                                    <p className="rounded-full mr-4 text-sm w-6/12 text-left">Saldo en tarjeta</p>
                                    <p className="rounded-full text-sm w-6/12 text-right">{FormatAmount(info.estimates?.USD)}</p>
                                </div>
                                <div className="flex items-center px-1 leading-7">
                                    <p className="rounded-full mr-4 text-sm w-6/12 text-left">Total COP</p>
                                    <p className="rounded-full text-sm w-6/12 text-right">{FormatAmount(info.estimates?.debit_COP)}</p>
                                </div>
                                <div className="flex items-center px-1 leading-7">
                                    <p className="rounded-full mr-4 text-sm w-4/12 text-left">Fecha</p>
                                    <p className="rounded-full text-sm w-8/12 text-right">
                                        {moment().format('YYYY-MM-DD HH:mm:ss A')}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center pb-6">
                            <button
                                className={`w-1/2 bg-${variablesDomain.classNameColor} hover:bg-${variablesDomain.classNameColor} border-${variablesDomain.classNameColor} hover:border-${variablesDomain.classNameColor} text-sm border-4 text-white py-2 rounded-full button-outline-off`}
                                onClick={() => {
                                    handleOk()
                                }}
                            >
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed inset-0 z-40" style={{
                background: 'rgba(47, 46, 44, 0.5)',
                backdropFilter: 'blur(10px)',
            }}></div>
        </>
    );
}